import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  FormControl,
  OutlinedInput,
  Button,
} from "@mui/material";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";

const logoImage =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/logo%2Fmg-icon-006.webp?alt=media&token=cc8c9019-2e23-443d-9e0a-206b6380069b";

const centralLogo =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/logo%2Fcentrallogo.png?alt=media&token=e222429b-fca4-475a-8079-b41e481e08e9";

const ProfilePage = ({ login, passwordChange }) => {
  const navigate = useNavigate();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async () => {
    try {
      await passwordChange(
        login.token,
        login.user_id,
        currentPassword,
        newPassword
      );

      // reset fields
      setCurrentPassword("");
      setNewPassword("");

      // redirect
      navigate("/admin");
    } catch (error) {
      console.error("Error updating password:", error);
    }
  };

  return (
    <Grid>
      <Dialog
        open={true}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: "10px",
            padding: "20px",
          },
        }}
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} textAlign="center" mb={2}>
              <img src={centralLogo} alt="Logo" className="logoImage" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <img src={logoImage} alt="Profile" className="responsiveImage" />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="h4" textAlign="center">
                Profile
              </Typography>

              {/* Name */}
              <Grid mt={4}>
                <Typography color="#ccc">Name *</Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={login?.name}
                  InputProps={{
                    style: { backgroundColor: "#333", color: "#fff" },
                  }}
                />
              </Grid>

              {/* Email */}
              <Grid mt={2}>
                <Typography color="#ccc">Email *</Typography>
                <TextField
                  fullWidth
                  size="small"
                  value={login?.email}
                  InputProps={{
                    style: { backgroundColor: "#333", color: "#fff" },
                  }}
                />
              </Grid>

              {/* Current Password */}
              <Grid mt={2}>
                <Typography color="#ccc">Current Password *</Typography>
                <FormControl fullWidth>
                  <OutlinedInput
                    type={showPassword ? "text" : "password"}
                    size="small"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <EyeOff color="white" />
                          ) : (
                            <Eye color="white" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    style={{ backgroundColor: "#333", color: "#fff" }}
                  />
                </FormControl>
              </Grid>

              {/* New Password */}
              <Grid mt={2}>
                <Typography color="#ccc">New Password *</Typography>
                <FormControl fullWidth>
                  <OutlinedInput
                    type={showPassword ? "text" : "password"}
                    size="small"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <EyeOff color="white" />
                          ) : (
                            <Eye color="white" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    style={{ backgroundColor: "#333", color: "#fff" }}
                  />
                </FormControl>
              </Grid>

              {/* Button */}
              <center>
                <Button
                  variant="contained"
                  sx={{
                    mt: 5,
                    backgroundColor: "#ff0000",
                    "&:hover": { backgroundColor: "#d00000" },
                  }}
                  onClick={handleSubmit}
                >
                  Update Profile
                </Button>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ProfilePage;